import { BooleanInput, Edit, FormDataConsumer, SimpleForm, TextInput, useNotify } from 'react-admin';
import AddToLokaliseButton from '../../Components/AddToLokaliseButton';
import { useNavigate } from 'react-router-dom';

const jsonFormat = (value: unknown) => (value && typeof value === 'object' ? JSON.stringify(value, null, 2) : (value as string) ?? '{}');
const jsonParse = (value: string) => {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
};

const RequestSubtypeTemplatesEdit = () => {
  const navigate = useNavigate();
  const notify = useNotify();
  return (
    <Edit
      mutationMode="pessimistic"
      mutationOptions={{
        onSuccess: () => {
          notify('Saved');
          navigate(-1);
        }
      }}
    >
      <SimpleForm>
        <TextInput disabled source="uuid" label="UUID" />
        <TextInput disabled source="requestTypeTemplateUuid" label="Type Template UUID" fullWidth />
        <TextInput disabled source="country" label="Country" />
        <TextInput disabled source="name" label="Name" />
        <TextInput source="nameId" label="Name ID" required />
        <TextInput source="translationKey" label="Translation Key" required />
        <FormDataConsumer>{({ formData }) => <AddToLokaliseButton translationKey={formData.translationKey} />}</FormDataConsumer>
        <BooleanInput source="active" label="Active" />
        <TextInput source="template" label="Template (JSON)" multiline fullWidth minRows={8} format={jsonFormat} parse={jsonParse} required />
      </SimpleForm>
    </Edit>
  );
};

export default RequestSubtypeTemplatesEdit;
